import React from 'react'
import { Link } from "react-router-dom";

const PrincipalsMessage = () => {
  return (
    <>
      <div className="site-breadcrumb" style={{ background: 'url(assets/school/about.webp)' }}>
        <div className="container">
          <h2 className="breadcrumb-title">Principals Message</h2>
          <ul className="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li className="active" style={{ color: "red" }}>Principals Message</li>
          </ul>
        </div>
      </div>


      <div className="team-single pt-120 pb-80">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-4">
              <div className="team-single-img">
                <img src="assets/school/Sanjay Tripathi.webp" alt />
              </div>
            </div>
            <div className="col-md-8">
              <div className="team-details">
                <h3>Mr. Sanjay Tripathi</h3>
                <strong>Principals Message</strong>
                <p className="mt-3" style={{ textAlign: "justify" }}>

                  Education is not just about acquiring knowledge; it is about shaping character, building confidence, and preparing students to face the challenges of life with courage and integrity. At our school, we strive to create a nurturing environment where every child feels valued, respected, and inspired to achieve their full potential.

                  We believe that each student is unique, with their own strengths and talents. Our dedicated and experienced teachers work tirelessly to provide quality education that promotes academic excellence along with moral values, creativity, and critical thinking. Along with academics, we encourage students to participate in sports, cultural activities, and community service to ensure their holistic development.

                </p>
                <div className="team-details-info">
                  <ul>
                    <li>
                      <Link to="https://share.google/Fsl3aMdnrCaBHv8Ae" target="_blank"><i className="far fa-location-dot" /> Swami Chowk, Mukhtiyarganj Satna (M.P.)</Link>
                    </li>
                    <li>
                      <Link to="mailto:pchs.satna@gmail.com"><i className="far fa-envelopes" /> pchs.satna@gmail.com</Link>
                    </li>
                    <li>
                      <Link to="tel:7987105491"><i className="far fa-phone-volume" /> +91 7987105491</Link>
                    </li>
                  </ul>
                </div>
                <div className="team-details-social">
                  <Link to="https://www.facebook.com/Pchs.satna/" target="_blank"><i className="fab fa-facebook-f" /></Link>
                  <Link to="https://wa.me/917987105491"><i className="fab fa-whatsapp" target="_blank" /></Link>
                  <Link to="https://www.instagram.com/pchschool?igsh=MTVpdHltbDl3N2lxbw%3D%3D"><i className="fab fa-instagram" target="_blank" /></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="biography-skil pb-120">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="biography">
                {/* <h4 className="mb-3">Biography</h4> */}
                <p className="mb-10" style={{ textAlign: "justify" }}>
                  In today’s rapidly changing world, it is our responsibility to equip students with not only knowledge but also essential life skills such as discipline, teamwork, empathy, and leadership. With the support of parents and the commitment of our staff, we aim to build a strong foundation that helps our students become responsible citizens and lifelong learners.

                  I extend my heartfelt gratitude to parents for their trust and cooperation. Together, let us continue to guide our children towards a bright, successful, and meaningful future.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="team-skill">
                <h4 className="mb-3">Professional Skills</h4>
                <div className="skills-section">
                  <div className="progress-box">
                    <h5>Communication <span className="pull-right">99%</span></h5>
                    <div className="progress" data-value={99}>
                      <div className="progress-bar" role="progressbar" style={{ width: '99%' }} />
                    </div>
                  </div>
                  <div className="progress-box">
                    <h5>Relationship <span className="pull-right">98%</span></h5>
                    <div className="progress" data-value={98}>
                      <div className="progress-bar" role="progressbar" style={{ width: '98%' }} />
                    </div>
                  </div>
                  <div className="progress-box">
                    <h5>Creative Work <span className="pull-right">99%</span></h5>
                    <div className="progress" data-value={99}>
                      <div className="progress-bar" role="progressbar" style={{ width: '99%' }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default PrincipalsMessage